var map = {
	"./CUIT.png": 24,
	"./MUN.png": 23,
	"./airbnbLogo.png": 119,
	"./codeInLogo.webp": 40,
	"./contactMail.webp": 120,
	"./contactMailDark.svg": 121,
	"./developerActivity.svg": 122,
	"./facebookLogo.png": 123,
	"./googleAssistant.svg": 124,
	"./googleAssistantLogo.webp": 41,
	"./harvardLogo.png": 125,
	"./jiance.jpg": 126,
	"./jiuzhou.jpg": 37,
	"./jsFramework.svg": 127,
	"./manOnTable.svg": 128,
	"./morgan.jpg": 35,
	"./nextuLogo.webp": 39,
	"./profile.jpg": 44,
	"./programmer.svg": 45,
	"./projects/Color.gif": 26,
	"./projects/IK_GIF2.gif": 27,
	"./projects/ball.gif": 32,
	"./projects/platform.gif": 31,
	"./projects/recog.PNG": 30,
	"./projects/scifi.gif": 28,
	"./projects/shoot.gif": 33,
	"./projects/subway.gif": 29,
	"./projects/tank.gif": 25,
	"./pwa.webp": 129,
	"./pwaLogo.webp": 42,
	"./quoraLogo.png": 130,
	"./saayaHealthLogo.webp": 38,
	"./skill.svg": 131,
	"./skillrate.svg": 46,
	"./stanfordLogo.png": 132,
	"./talksCardBack.svg": 133,
	"./talksCardBackAlt.svg": 134,
	"./tc.jpg": 34,
	"./thumb.png": 135,
	"./wisesoft.jpg": 36
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 118;